export const CALLOVER_LIST_VIEW_BY_GROUP = 'CALLOVER_LIST_VIEW_BY_GROUP'
export const CALLOVER_LIST_VIEW_BY_NAME = 'CALLOVER_LIST_VIEW_BY_NAME'



/** WEBPACK FOOTER **
 ** ./src/constants/performance-page-constants.js
 **/